const tags = ['Participation'];

export { tags };
